import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import { ShellProvider } from "@/components/layout/ShellContext";
import Sidebar from "@/components/layout/Sidebar";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";

/** App shell, structured like Medilearn/admin-panel: Sidebar | (Header / main / Footer). */
export default function Layout() {
  const { pathname } = useLocation();
  return (
    <ShellProvider>
      <div className="flex h-screen overflow-hidden bg-surface">
        <Sidebar />
        <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
          <Header />
          <main className="flex-1 overflow-y-auto">
            <div key={pathname} className="p-4 lg:p-5 space-y-4 animate-fade-in">
              <Outlet />
            </div>
          </main>
          <Footer />
        </div>
      </div>
    </ShellProvider>
  );
}
